import Vue from 'vue'
import {ActionTree, MutationTree} from 'vuex'
import {RootState} from '@/store/types'

import {Show} from '@/store/modules/lib'
import axios from 'axios';
import alerts from '@/store/modules/alerts';
import i18n from "@/helpers/i18n";

export interface State {
  appeals:any[],
  appealsCount:number,
  loadingAppeals:boolean,
  accounts:any
  accountsCount: number,
  errorEditAccount: boolean,
  errorBlockAccount: boolean,
}


const defaultState: State = {
  appeals:[],
  appealsCount:0,
  loadingAppeals:true,
  accounts:[],
  accountsCount:0,
  errorEditAccount: false,
  errorBlockAccount: false
};

const getters = {
  appeals: (state: State) => state.appeals,
  appealsCount: (state: State) => state.appealsCount,
  loadingAppeals: (state: State) => state.loadingAppeals,
  accounts: (state: State) => state.accounts,
  accountsCount: (state: State) => state.accountsCount,
  errorEditAccount: (state: State) => state.errorEditAccount,
  errorBlockAccount: (state: State) => state.errorBlockAccount,
}

const mutations: MutationTree<State> = {
  setAppeals(state: State, payload:any) {
    payload[0].models.forEach((item:any) => item.loading = false)
    state.appeals = payload[0].models
    state.appealsCount = payload[0].allCount
  },
  setLoadingAppeals(state: State, payload: boolean) {
    state.loadingAppeals = payload
  },
  setAccounts(state: State, payload:any) {
    state.accounts = payload.models
    state.accountsCount = payload.allCount
  },
  setAccount(state: State, payload:any) {
    payload.loadingBlock = false
    let items:any = []
    payload.companies.forEach((company:any) => items.push(company.companyTitle))
    payload.currentCompanies = items.join(', ')

    state.accounts = state.accounts.map((account:any)=>{
      return account._id == payload._id ? payload : account
    })
  },
    setAccountTP(state: State, payload:any) {
    payload.loadingTp = false
    let items:any = []
    payload.companies.forEach((company:any) => items.push(company.companyTitle))
    payload.currentCompanies = items.join(', ')
    state.accounts = state.accounts.map((account:any)=>{
      return account._id == payload._id ? payload : account
    })
  },
  setErrorEditAccount(state: State, payload:boolean) {
    state.errorEditAccount = payload
  },
  setErrorBlockAccount(state: State, payload:boolean) {
    state.errorBlockAccount = payload
  },
}

const actions: ActionTree<State, RootState> = {
  async loadAppealsFromServer({commit, state},payload:any) {
    commit('setLoadingAppeals', true)
    try {
      const {data} = await Vue.axios.get(
        '/v5/support/appeals?' +
        'page=' + payload.page +
        '&per-page=' + payload.itemsPerPage +
        '&sort=' + payload.sort +
        '&reason=' + payload.reason +
        '&status=' + payload.status +
        '&search=' + payload.search)
      if(data.error){
        throw (data.error)
      }
      commit('setAppeals', data.data)
      commit('setLoadingAppeals', false)
    } catch (e) {
      this.commit('alerts/setAlert', {
        show: true,
        color: 'red',
        messages: [e]
      })
      console.log(e.message)
      commit('setLoadingAppeals', false)
    }
  },
  async changeStatusFromServer({commit, state},payload:any) {
    try {
      const {data} = await Vue.axios.patch('/v5/support/appeal/' + payload._id, payload.params)
      if(data.error){
        throw (data.error)
      }
      this.commit('alerts/setAlert', {
        show: true,
        color: 'green',
        messages: [i18n.t('common.changes_save')]
      })
    } catch (e) {
      this.commit('alerts/setAlert', {
        show: true,
        color: 'red',
        messages: [e]
      })
      console.log(e.message)
    }
  },
  async loadAccountsFromServer({commit, state},payload:any) {
    try {
      const {data} = await Vue.axios.get('/v5/users?',{
          params:{
              page:payload.page,
              'per-page':payload.itemsPerPage,
              role:payload.role,
              search: payload.search
          }
      })
      if(data.error){
        throw (data.error)
      }

      data.data.models.forEach((account:any) => {
        account.loadingBlock = false
        account.loadingTp = false
        let items:any = []
        account.companies.forEach((company:any) => items.push(company.companyTitle))
        account.currentCompanies = items.join(', ')
      })
      data.data.models.forEach((account:any) => account.showTooltip = false)
      commit('setAccounts', data.data)
    } catch (e) {
      this.commit('alerts/setAlert', {
        show: true,
        color: 'red',
        messages: [e]
      })
      console.log(e.message)
    }
  },
  async blockAccountFromServer({commit, state},payload:any) {
    commit('setErrorBlockAccount', false)
    try {
      const {data} = await Vue.axios.post(`/v5/user/${payload}/block`)
      if(data.error){
        throw (data.error)
      }
      commit('setAccount', data.data.account)
    } catch (e) {
      this.commit('alerts/setAlert', {
        show: true,
        color: 'red',
        messages: [e]
      })
      console.log(e.message)
      commit('setErrorBlockAccount', true)
    }
  },
  async unblockAccountFromServer({commit, state},payload:any) {
    commit('setErrorBlockAccount', false)
    try {
      const {data} = await Vue.axios.post(`/v5/user/${payload}/unblock`)
      if(data.error){
        throw (data.error)
      }
      commit('setAccount', data.data.account)
    } catch (e) {
      this.commit('alerts/setAlert', {
        show: true,
        color: 'red',
        messages: [e]
      })
      commit('setErrorBlockAccount', true)
      console.log(e.message)
    }
  },
    async lockAccountFromServerTp({commit, state},payload:any) {
        commit('setErrorBlockAccount', false)
        try {
            const {data} = await Vue.axios.patch(`/v5/admin/${payload._id}/role`,{
                role:payload.role
            })
            if(data.error){
                throw (data.error)
            }
            commit('setAccountTP', payload)
        } catch (e) {
            this.commit('alerts/setAlert', {
                show: true,
                color: 'red',
                messages: [e]
            })
            commit('setErrorBlockAccount', true)
        }
    },
  async editAccountFromServer({commit, state},payload:any) {
    try {
      const {data} = await Vue.axios.patch(`/v5/user/${payload.id}/login/change`, payload.params)
      if(data.error){
        throw (data.error)
      }
      commit('setAccount', data.data.account)
      commit('setErrorEditAccount', false)
    } catch (e) {
      this.commit('alerts/setAlert', {
        show: true,
        color: 'red',
        messages: [e]
      })
      console.log(e.message)
      commit('setErrorEditAccount', true)
    }
  },
  async runScriptFromServer({commit, state},payload:any) {
    try {
      const {data} = await Vue.axios.post(`/v5/script/fix-shards/start`, payload)
      if(data.error){
        throw (data.error)
      }
      this.commit('alerts/setAlert', {
        show: true,
        color: 'red',
        messages: [i18n.t('script.tooltip_success')]
      })
      return true
    } catch (e) {
      this.commit('alerts/setAlert', {
        show: true,
        color: 'red',
        messages: [i18n.t('common.notifications.error.no_name')]
      })
      return false
    }
  },
}

export default {
  namespaced: true,
  state: defaultState,
  getters,
  mutations,
  actions
}
